<script>
export default {
  name: 'FormField',

  props: {
    disabled: {
      default: false,
      type: Boolean,
    },

    id: {
      default: null,
      type: String,
    },

    invalid: {
      default: false,
      type: Boolean,
    },

    placeholder: {
      default: null,
      type: String,
    },

    required: {
      default: false,
      type: Boolean,
    },

    theme: {
      default: null,
      type: String,
    },

    value: {
      type: [Array, Object, Number, String],
      default: null,
    },

    rows: {
      type: [Number, String],
      default: 5,
    },

    readonly: {
      type: Boolean,
      default: false,
    },

    withClear: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    model: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      },
    },
  },

  methods: {
    clear() {
      this.model = null;
    },
  },
};
</script>
